var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.7157 14.6447C19.7631 12.692 16.5973 12.692 14.6446 14.6447C12.692 16.5973 12.692 19.7631 14.6446 21.7157L42.929 50.0001L14.6447 78.2844C12.692 80.237 12.692 83.4028 14.6447 85.3554C16.5973 87.308 19.7631 87.308 21.7157 85.3554L50 57.0711L78.2842 85.3553C80.2369 87.308 83.4027 87.308 85.3553 85.3553C87.3079 83.4027 87.3079 80.2369 85.3553 78.2843L57.0711 50.0001L85.3553 21.7158C87.308 19.7632 87.308 16.5974 85.3553 14.6447C83.4027 12.6921 80.2369 12.6921 78.2843 14.6447L50 42.929L21.7157 14.6447Z"}));
}

Close.defaultProps = {"viewBox":"0 0 100 100","fill":"currentColor"};

module.exports = Close;

Close.default = Close;
